import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IOrganization, IOrg } from '../dto/Organization';
import { supervisingModule } from '../../../store/modules/OperationSupervising';
import { KanriConstants } from '@/Kanri/fixed/KanriConstants';

@Module({ dynamic: true, store, name: 'organization', namespaced: true })
class Organization extends VuexModule implements IOrganization {
    // state
    /**
     * @state
     * データ移動状態
     */
    moveState = '0';

    /**
     * @state
     * 組織情報
     */
    organization: IOrg = {
        szkCd: '',
        naibCd: '',
        kanriNo: '',
    };

    /**
     * @state
     * 再検索フラグ
     * ='1'の時再検索を行う
     */
    reSearchFlag = '0';

    /**
     * @state
     * フォームデータ
     * 検索条件を格納する
     */
    formData: any = [];

    // getter
    /**
     * @Getter
     * パスの取得
     */
    get GET_PATH() {
        return `/${this.organization.szkCd}/${this.organization.naibCd}/${this.organization.kanriNo}`;
    }

    /**
     * @Getter
     * 登録処理用パスの取得
     */
    get GET_REGIST_PATH() {
        if (supervisingModule.CHECK_MODE_UPDATE) {
            return KanriConstants.ORG_PATH + '/update' + this.GET_PATH;
        } else {
            return KanriConstants.ORG_PATH + '/create';
        }
    }


    /**
     * @Getter
     * 排他パスの取得
     */
    get GET_EXCLUSIVE_PATH() {
        return `/exclusive/${this.organization.szkCd}/${this.organization.naibCd}/${this.organization.kanriNo}`;
    }

    /**
     * @Getter
     * 排他パスの取得
     */
    get GET_EXCLUSIVE_DELETE_PATH() {
        return `/exclusive/delete/${this.organization.szkCd}/${this.organization.naibCd}/${this.organization.kanriNo}`;
    }


    /**
     * @Getter
     * 移動状況の確認
     */
    get CHECK_MOVE_STATE() {
        if (this.moveState === '1') {
            return true;
        }
        return false;
    }

    /**
     * @getter
     * reSearchFlagの取得
     * 1ならtrueを返す
     */
    get CHECK_RE_SEARCH() {
        if (this.reSearchFlag === '1') {
            return true;
        }
        return false;
    }

    /**
     * @Getter
     * formDataの取得
     */
    get GET_FORM_DATA() {
        return this.formData;
    }

    // action
    /**
     * @Action
     * 組織情報の保管
     * @param param (IOrg)組織情報
     */
    @Action({})
    public setOrg(param: IOrg) {
        this.SET_ORG(param);
    }

    /**
     * @Action
     * 登録画面移動時のフラグ変更
     */
    @Action({})
    public transferToInfo() {
        this.TRANSFER_TO_INFO();
    }

    /**
     * @Action
     * 登録画面到着時のフラグ変更
     */
    @Action({})
    public arrivalToInfo() {
        this.MOVE_COMPLETE();
    }

    /**
     * @Action
     * フォームデータの保管
     * @param data
     */
    @Action({})
    public setFormData(data: any) {
        this.SET_FORM_DATA(data);
    }

    /**
     * @Action
     * 検索画面移動時のフラグ変更
     */
    @Action({})
    public transferToSearch() {
        this.TRANSFER_TO_SEARCH();
    }

    /**
     * @Action
     * 検索画面到着時のフラグ変更
     */
    @Action({})
    public arrivalToSearch() {
        this.MOVE_COMPLETE();
    }

    /**
     * @Action
     * モジュールリセット
     */
    @Action({})
    public moduleReset() {
        this.MODULE_RESET();
    }

    /**
     * @Action
     * モジュール選択情報リセット
     */
    @Action({})
    public moduleSelectReset() {
        this.MODULE_ORG_RESET();
    }

    // mutation
    /**
     * @Mutation
     * 組織情報の保管
     * @param param (IOrg)組織情報
     */
    @Mutation
    private SET_ORG(param: IOrg) {
        this.organization = param;
    }

    /**
     * @Mutation
     * 登録画面移動時のフラグ変更
     */
    @Mutation
    private TRANSFER_TO_INFO() {
        this.moveState = '1';
    }

    /**
     * @Mutation
     * 移動処理完了時のフラグ変更
     */
    @Mutation
    private MOVE_COMPLETE() {
        this.moveState = '0';
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_FORM_DATA(data: any) {
        this.reSearchFlag = '1';
        this.formData = data;
    }

    /**
     * @Mutation
     */
    @Mutation
    private TRANSFER_TO_SEARCH() {
        this.moveState = '2';
    }

    /**
     * @Mutation
     */
    @Mutation
    private MODULE_RESET() {
        this.moveState = '0';
        this.organization = {
            szkCd: '',
            naibCd: '',
            kanriNo: '',
        };
        this.reSearchFlag = '0';
        this.formData = [];
    }

    /**
     * @Mutation
     */
    @Mutation
    private MODULE_ORG_RESET() {
        this.moveState = '0';
        this.organization = {
            szkCd: '',
            naibCd: '',
            kanriNo: '',
        };
    }

}

export const organizationModule = getModule(Organization);
